import { useMutation } from "react-query";
import { useDirections } from "./useDirections";
import { DirectionsPostSchema } from "../model/shema";

interface MutateOptions {
  onSuccess?: (data?: any) => void;
  onError?: (error: any) => void;
}

interface DataIProps {
  data: DirectionsPostSchema;
  options?: MutateOptions;
}

export const useCreateDirection = () => {
  const { directionsCreate } = useDirections();

  const mutation = useMutation({
    mutationFn: async (props: DataIProps) => {
      const result = await directionsCreate(props.data);
      if (result.data) {
        return result.data;
      } else {
        throw new Error("Не удалось сохранить договор");
      }
    },
    onSuccess: (data, { options }) => {
      options?.onSuccess?.(data);
    },
    onError: (error, { options }) => {
      options?.onError?.(error);
    },
  });

  const create = (data: DirectionsPostSchema, options?: MutateOptions) => {
    mutation.mutate({ data, options });
  };

  return { create };
};
